import React from "react";
import { Lightbulb, Video } from "lucide-react";
import { useAcademy } from "./AcademyContext";

// Da mettere accanto al titolo (h1) di ogni pagina pilotata da DF Academy:
// vicino al testo che l'utente sta già leggendo si nota molto di più che
// perso in mezzo alle altre icone dell'header, ed è anche meno affollamento
// nella barra in alto su schermi piccoli. Non mostra nulla se questa pagina
// non ha ancora contenuto.
export default function AcademyTitleBadge() {
  const { content, openGuide, openVideo } = useAcademy();
  if (!content) return null;
  return (
    <span className="inline-flex items-center gap-1.5 align-middle">
      {content.has_guide && (
        <button
          type="button"
          onClick={openGuide}
          className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full border border-amber-300 bg-amber-50 px-2.5 text-amber-700 shadow-sm transition-colors hover:bg-amber-100"
          aria-label="Apri la guida di questa pagina"
          title="Guida"
          data-testid="academy-open-guide"
        >
          <Lightbulb className="h-4 w-4" />
          <span className="hidden text-xs font-semibold sm:inline">Guida</span>
        </button>
      )}
      {content.has_video && (
        <button
          type="button"
          onClick={openVideo}
          className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full border border-sky-300 bg-sky-50 px-2.5 text-sky-700 shadow-sm transition-colors hover:bg-sky-100"
          aria-label="Apri la videoguida di questa pagina"
          title="Videoguida"
          data-testid="academy-open-video"
        >
          <Video className="h-4 w-4" />
          <span className="hidden text-xs font-semibold sm:inline">Video</span>
        </button>
      )}
    </span>
  );
}
